<div
    class="flex flex-col gap-3 border-r h-full w-full"
    [class.lg:w-[25rem]]="open()"
>
    @if (ticketId()) {
        <div animate.enter="fade-in" class="w-full">
            <ng-container *ngTemplateOutlet="childInfo" />
            @if (open()) {
                <ng-container *ngTemplateOutlet="segmentSection" />
                @if (segment() === "document-box") {
                    <app-document-box animate.enter="fade-in" />
                } @else {
                    <app-schedule-log animate.enter="fade-in" />
                }
            }
        </div>
    } @else {
        <app-document-select animate.enter="fade-in" />
    }
</div>

<ng-template #childInfo>
    @if (ticketId()) {
        @if (currentTicket(); as ticket) {
            @if (open()) {
                @if (currentChild(); as currentChild) {
                    <app-document-child-info
                        [currentChild]="currentChild"
                        (back)="handleBack()"
                    />
                }
                <div class="flex w-full justify-between items-center p-4">
                    <div class="flex gap-3 items-center">
                        @if (ticket.voucher) {
                            <app-badge variant="outline">바우처</app-badge>
                        } @else {
                            <app-badge variant="outline" color="gray"
                                >일반</app-badge
                            >
                        }
                        <div class="flex flex-col gap-0.5">
                            <p class="text-gray-800 font-medium">
                                {{ ticket.name }}
                            </p>
                            <p class="text-gray-400 text-sm">
                                {{ ticket.startAt | date: "y.MM.dd" }}
                                ~
                                @if (ticket.endAt) {
                                    {{ ticket.endAt | date: "y.MM.dd" }}
                                }
                            </p>
                        </div>
                    </div>

                    @if (ticket?.enrollment?.teacher; as teacher) {
                        <div class="flex gap-2 items-center">
                            <div
                                class="rounded-full size-2"
                                [style.backgroundColor]="teacher?.color"
                            ></div>
                            <p class="font-medium text-gray-700 text-sm">
                                {{ teacher.username }}
                            </p>
                        </div>
                    }
                </div>
            }
        }
    }
</ng-template>

<ng-template #segmentSection>
    <div
        class="px-3 py-2 flex gap-2.5 bg-[#EDEFF1] border-y h-[3.5rem] lg:h-[4rem]"
    >
        <button
            (click)="handleRoute('/document/document-box')"
            class="rounded-xl flex-1 border transition-colors"
            [ngClass]="
                segment() === 'document-box'
                    ? '*:text-gray-800 bg-white'
                    : '*:text-gray-500 border-transparent'
            "
        >
            <p class="text-xs lg:text-sm">문서함</p>
        </button>
        <button
            (click)="handleRoute('/document/schedule-log')"
            class="rounded-xl flex-1 border transition-colors"
            [ngClass]="
                segment() === 'schedule-log'
                    ? '*:text-gray-800 bg-white'
                    : '*:text-gray-500 border-none border-transparent'
            "
        >
            <p class="text-xs lg:text-sm">회기일지</p>
        </button>
    </div>
</ng-template>
